import { render, staticRenderFns } from "./TestPagingDraggingList.vue?vue&type=template&id=5948b1a5&scoped=true"
import script from "./TestPagingDraggingList.vue?vue&type=script&lang=js"
export * from "./TestPagingDraggingList.vue?vue&type=script&lang=js"
import style0 from "./TestPagingDraggingList.vue?vue&type=style&index=0&id=5948b1a5&prod&scoped=true&lang=less"
import style1 from "./TestPagingDraggingList.vue?vue&type=style&index=1&id=5948b1a5&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5948b1a5",
  null
  
)

export default component.exports